import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchPatientTrials = async (patientId) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/get_patient_trials/${patientId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetPatientTrials = ({ patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["patient_trials", patientId],
    queryFn: () => fetchPatientTrials(patientId),
    enabled: enabled && Boolean(patientId),
    refetchOnWindowFocus: false,
  });
};

export const usePrefetchPatientTrialsData = () => {
  const queryClient = useQueryClient();

  const prefetch = ({ patientId }) => {
    if (!patientId) return;

    queryClient.prefetchQuery({
      queryKey: ["patient_trials", patientId],
      queryFn: () => fetchPatientTrials(patientId),
    });
  };

  return prefetch;
};

export default useGetPatientTrials;
